<!-- 页面内容 -->
<template>
	<div class="cEmpty">
		<el-empty description=" " />
	</div>
</template>

<script setup lang="ts">
</script>

<style lang='scss' scoped>
.cEmpty {
	min-height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>